<div class="manual-assignment-file-upload">
  <div class="d-flex justify-content-between manual-assignment-file-upload__input-wrapper">
    <input
      #fileInput
      type="file"
      class="manual-assignment-file-upload__input d-none"
      [attr.multiple]="multiple || null"
      [accept]="allowedExtensions"
      (change)="fileChanged($event)">

    <div class="manual-assignment-file-upload__file" (click)="fileInput.click()">
      <span class="manual-assignment-file-upload__file-name">
        {{ files?.length > 1 ? (files?.length + ' files selected') : files?.[0]?.name  }}
      </span>
    </div>

    <button color="primary" class="manual-assignment-file-upload__upload-btn" mat-fab aria-label="Upload file" (click)="fileInput.click()">
      <mat-icon svgIcon="lms-upload-file"></mat-icon>
    </button>
  </div>
  <div class="manual-assignment-file-upload__bottom">
    @if (maxAllowedFileSizeInMb) {
      <div class="mr-3">Maximum file size: {{maxAllowedFileSizeInMb}} MB</div>
    }
    @if (allowedExtensions) {
      <div class="mr-3">Allowed extensions: {{allowedExtensions}}</div>
    }
  </div>
</div>
